<!--列表查看视图-->
<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Message.BookingSeal')"
      width="600px"
    >
      <div style="width: 560px; height: 370px;display: flex;overflow: auto;">
        <viewer :images="photoList">
          <img v-for="(item, index) in photoList" :key="index" :src="item.src" height="120" width="120" :title="item.fileName" style="margin:25px;">
        </viewer>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { cacheName, cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import URL from '@/api/urlTranslator'

export default {
  name: 'StampPictureView',
  components: {},
  props: {
    visible: { type: Boolean, required: true },
    businessDocuments: { type: Array, required: true }
  },
  data: function() {
    return {
      innerVisible: false,
      storageURL: '',
      photoList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQueryFiles()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    if (this.visible) {
      this.innerVisible = true
      this.toQueryFiles()
    }
  },
  methods: {
    // 查询进仓文件
    toQueryFiles() {
      // this.$logger.log('businessDocuments==========', this.businessDocuments)
      if (!this.businessDocuments || this.businessDocuments.length <= 0) {
        this.innerVisible = false
        return
      }
      this.photoList = []
      this.toQueryPhotos()
    },
    // 查询缩略图文件
    toQueryPhotos() {
      const docs = this.filterImages()
      if (!docs || docs.length <= 0) return
      for (const doc of docs) {
        if (!doc.documentId) continue
        doc.src = `${URL.common.findByFileId}/${doc.documentId}?sessionId=${this.$store.getters.token}`
        this.photoList.push(doc)
      }
      // this.$logger.log('photoList==========', this.photoList)
    },
    // 过滤订舱章图片
    filterImages() {
      const images = []
      for (const doc of this.businessDocuments) {
        if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
        if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
        images.push(doc)
      }
      return images
    }
  }
}
</script>
